import { useRef as s, useEffect as o } from "react";
const f = (r) => {
  const e = s(null);
  return o(() => {
    var t;
    r && ((t = e.current) == null || t.focus());
  }, [r, e]), { refForFirstItem: e };
};
export {
  f as useFocusFirstItemWhenAutoFocus
};
//# sourceMappingURL=index.es5533.js.map
